import {
  getAuth,
  setPersistence,
  browserLocalPersistence, // For Persistence.LOCAL
  signInWithPopup,
  OAuthProvider,          // For Apple Sign in
  GoogleAuthProvider,     // For FirebaseUI Google Sign in
  EmailAuthProvider,       // For FirebaseUI Email Sign in
  onAuthStateChanged,
  createUserWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail
} from 'firebase/auth';
import { app } from './initialise.js'; // Import the initialized app

// Get the Auth service instance, linked to the initialized app
const auth = getAuth(app);

// Set persistence (equivalent to firebase.auth.Auth.Persistence.LOCAL)
// This should ideally be called early, perhaps even here or right after auth init.
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log("Firebase Auth persistence set to local.");
  })
  .catch((error) => {
    console.error("Error setting Firebase Auth persistence:", error);
  });

// --- Sign-in Methods ---

// Apple Sign-in (replaces firebase.hiikerSignInWithApple)
async function signInWithApple(signInSuccessUrl = '/profile') {
  const provider = new OAuthProvider('apple.com');
  provider.addScope('email');
  provider.addScope('name');

  try {
    const userCredential = await signInWithPopup(auth, provider); // Use signInWithPopup from v9 SDK
    const idToken = await userCredential.user.getIdToken();
    const redirectUrl = `/firebase/auth?accessToken=${idToken}`; // Your backend endpoint
    window.location.assign(redirectUrl);
  } catch (error) {
    alert(error)
  }
}

// Export the auth instance and specific methods/providers needed elsewhere
export {
  auth,
  signInWithApple,
  // Export providers needed by FirebaseUI
  GoogleAuthProvider,
  EmailAuthProvider,
  onAuthStateChanged,
  signOut,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail
};
